import { AppRegistry } from 'react-native';
import { WebApp } from './WebApp';

document.documentElement.setAttribute('data-build-id', process.env.WEB_BUILD_ID ?? 'dev');

AppRegistry.registerComponent('ClubHouseWeb', () => WebApp);

const root = document.getElementById('root');
if (root) {
  AppRegistry.runApplication('ClubHouseWeb', {
    rootTag: root,
  });
}
